import axios from 'axios';
import { assign } from 'xstate';

import { publicWindow } from '../../config/public';

export const actions = {
  assignError: assign((ctx: any, e: any) => {
    const err = e.data;
    const message = err instanceof Error ? err.message : String(err);
    return { ...ctx, error: message };
  }),
  assignObject: assign((ctx: any) => {
    return {
      authParams: {
        COMPANY: ctx.objs[0].COMPANY,
        BRANCH: ctx.objs[0].BRANCH,
        MODULE: ctx.objs[0].MODULE,
        REFID: ctx.objs[0].REFID,
      },
    };
  }),
  assignSelectedObject: assign(({ branchActor }: any) => {
    const { selectedItems } = branchActor.getSnapshot().context;
    return {
      authParams: {
        COMPANY: selectedItems.COMPANY.value,
        BRANCH: selectedItems.BRANCH.value,
        MODULE: selectedItems.MODULE.value,
        REFID: selectedItems.REFID.value,
      },
    };
  }),
  assignCreds: assign((ctx: any, e: any) => {
    return { ...ctx, username: e.username, password: e.password };
  }),
  assignClientID: assign((ctx: any, e: any) => {
    return { ...ctx, clientID: e.data.clientID };
  }),
};

export const services = {
  logInService: async (ctx: any, e: any) => {
    const { username, password } = e;
    try {
      if (username.trim() <= 0 || password.trim() <= 0) {
        throw Error('Username or Password empty');
      }
      const isSSO = password.startsWith('SSO:');
      const loginEndpoint = isSSO ? ctx.API : ctx.API.replace('/api', '/portalLogin');
      const response = await axios.post(loginEndpoint, {
        username,
        password,
        ...(isSSO ? { service: 'login' } : { serviceName: publicWindow.loginService }),
        ...(isSSO ? { appId: publicWindow.appId } : {}),
      });
      const { data } = response;
      if (!data.success) {
        throw new Error(data.error);
      }
      return data;
    } catch (error) {
      if (error instanceof Error) throw error;
      throw new Error(String(error));
    }
  },
  authService: async (ctx: any) => {
    try {
      const response = await axios.post(ctx.API, {
        service: 'authenticate',
        clientID: ctx.loginClientID,
        ...ctx.authParams,
      });
      const { data } = response;
      if (!data.success) {
        throw new Error(data.error);
      }
      return data;
    } catch (error) {
      if (error instanceof Error) throw error;
      throw new Error(String(error));
    }
  },
};
